import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutCard = ({ 
  data = [],
  title = "Defects Summary"
}) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ padding: "20px" }}>
        <h2
          style={{
            marginBottom: "10px",
            fontSize: "15px",
            fontWeight: 600,
            color: "#18242D",
          }}
        >
          {title}
        </h2>
        <div
          style={{
            display: "flex",
            backgroundColor: "#FFFFFF",
            borderRadius: "0.375rem",
            padding: "1rem",
            gap: "1rem",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <div style={{ color: "#666", fontSize: "16px" }}>No data available</div>
        </div>
      </div>
    );
  }

  const processData = (rawData) => {
    const grouped = rawData.reduce((acc, item) => {
      const existing = acc.find(i => i.label === item.label);
      if (existing) {
        existing.count += item.count || 1;
      } else {
        acc.push({
          label: item.label,
          count: item.count || 1,
          color: item.color
        });
      }
      return acc;
    }, []);
    return grouped;
  };

  const processedData = processData(data);
  const totalDefects = processedData.reduce((sum, item) => sum + item.count, 0);

  const COLORS = [
    "#3366CC","#DC3912","#FF9900","#109618","#990099",
    "#0099C6","#DD4477","#66AA00","#B82E2E","#316395",
    "#994499","#22AA99","#AAAA11","#6633CC","#E67300",
    "#8B0707","#329262","#5574A6","#3B3EAC","#FF6600",
    "#0099C6","#DD4477","#66AA00","#B82E2E","#316395",
    "#994499","#22AA99","#AAAA11","#6633CC","#E67300",
  ];

  const chartData = {
    labels: processedData.map(item => item.label),
    datasets: [
      {
        data: processedData.map(item => item.count),
        backgroundColor: processedData.map((item, index) => 
          item.color || COLORS[index % COLORS.length]
        ),
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    cutout: "70%",
    plugins: { 
      legend: { display: false } 
    },
    maintainAspectRatio: false,
    spacing: 2,
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2
        style={{
          marginBottom: "10px",
          fontSize: "15px",
          fontWeight: 500,
          color: "#18242D",
        }}
      >
        {title}
      </h2>

      <div
        style={{
          display: "flex",
          backgroundColor: "#FFFFFF",
          borderRadius: "0.375rem",
          padding: "1rem",
          gap: "1rem",
        }}
      >
        {/* Left side - Chart */}
        <div
          style={{
            flex: "0 0 200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            height: "250px",
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            <Doughnut data={chartData} options={chartOptions} />
          </div>
          
          {/* Center text showing total */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: "22px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {totalDefects}
          </div>
        </div>

        {/* Right side - Labels grid */}
        <div
          style={{
            flex: "1",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: "15px 30px",
            paddingLeft: "20px",
            overflowY: "auto",
            maxHeight: "200px",
          }}
        >
          {processedData.map((item, index) => {
            const percent = ((item.count / totalDefects) * 100).toFixed(1);
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "13px",
                }}
              >
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    background: chartData.datasets[0].backgroundColor[index],
                    display: "inline-block",
                  }}
                />
                <span>
                  {item.label} - {item.count} 
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DoughnutCard;